import React from 'react';
import { Flex } from 'core/components';
import KaizenInput from './KaizenInput';
import { FancyInput, LargeHeading } from './KaizenChatSession.styles';

const KaizenEmptyState = ({
  inputRef,
  selectedJourney,
  placeholder = 'Ask anything about your network',
  createJourney,
  scrollToBottom,
  selectJourneyAfterCreation
}) => (
  <Flex flexDirection="column" justifyContent="center" alignItems="center" gap="6px" minWidth={750} flex={1}>
    <LargeHeading>AI Advisor</LargeHeading>
    <FancyInput mt={3}>
      <KaizenInput
        inputRef={inputRef}
        key={selectedJourney?.id || 'new-journey-input'}
        placeholder={placeholder}
        createJourney={createJourney}
        scrollToBottom={scrollToBottom}
        selectJourneyAfterCreation={selectJourneyAfterCreation}
      />
    </FancyInput>
  </Flex>
);

export default KaizenEmptyState;
